import {
    CLEAR_DASHBOARD_DETAILS,
    SET_DASHBOARD_DETAILS,
    DASHBOARD_DETAILS_ERROR,
    DASHBOARD_DETAILS_ERROR_CLEAR,
    DASHBOARD_DETAILS_PENDING,
    DASHBOARD_FILTER_DIALOG_OPEN,
    DASHBOARD_FILTER_DIALOG_CLOSE,
    SET_DASHBOARD_FILTER_DATA,
    SET_PRIMARY_ENTITY_GRAPH_DETAILS,
    CLEAR_PRIMARY_ENTITY_GRAPH_DETAILS,
    PRIMARY_ENTITY_GRAPH_DETAILS_PENDING,
    PRIMARY_ENTITY_GRAPH_DETAILS_ERROR,
    PRIMARY_ENTITY_GRAPH_DETAILS_ERROR_CLEAR,
    SET_TMLS_GRAPH_DETAILS,
    CLEAR_TMLS_GRAPH_DETAILS,
    TMLS_GRAPH_DETAILS_PENDING,
    TMLS_GRAPH_DETAILS_ERROR,
    TMLS_GRAPH_DETAILS_ERROR_CLEAR,
    SET_DYSBACTERIOSIS_GRAPH_DETAILS,
    CLEAR_DYSBACTERIOSIS_GRAPH_DETAILS,
    DYSBACTERIOSIS_GRAPH_DETAILS_PENDING,
    DYSBACTERIOSIS_GRAPH_DETAILS_ERROR,
    DYSBACTERIOSIS_GRAPH_DETAILS_ERROR_CLEAR,
    USER_DASHBOARD_DETAILS_PENDING,
    SET_USER_DASHBOARD_DETAILS,
    USER_DASHBOARD_DETAILS_ERROR,
    USER_DASHBOARD_DETAILS_ERROR_CLEAR,
    CLEAR_USER_DASHBOARD_DETAILS,
    FORM_FIELD_SELECT_DIALOG_OPEN,
    FORM_FIELD_SELECT_DIALOG_CLOSE,
    PRIMARY_ENTITY_GRAPH_TYPE,
    TMLS_GRAPH_TYPE,
    DYSBACTERIOSIS_GRAPH_TYPE,
} from "./constants"

const initialState = {
    //-----------------------------|| DETAILS ||---------------------------------------------------------------
    dashboardDetails: null,
    isDashboardDetailsPending: false,
    dashboardDetailsErrorMessage: null,
    //-----------------------------|| USER DASHBOARD DETAILS ||------------------------------------------------
    userDashboardDetails: null,
    isUserDashboardDetailsPending: false,
    userDashboardDetailsErrorMessage: null,
    //-----------------------------|| FIELD SELECT ||----------------------------------------------------------
    isFieldSelectDialogOpen: false,
    //-----------------------------|| GRAPH FILTER ||----------------------------------------------------------
    dashboardFilter: null,
    isDashboardFilterDialogOpen: false,
    //-----------------------------|| PRIMARY ENTITY GRAPH ||--------------------------------------------------
    primaryEntityGraphDetails: null,
    isPrimaryEntityGraphPending: false,
    primaryEntityGraphDetailsErrorMessage: null,
    //-----------------------------|| TMLS GRAPH ||------------------------------------------------------------
    TMLSGraphDetails: null,
    isTMLSGraphPending: false,
    TMLSGraphDetailsErrorMessage: null,
    //-----------------------------|| DYSBACTERIOSIS GRAPH ||--------------------------------------------------
    dysbacteriosisDetails: null,
    isDysbacteriosisGraphPending: false,
    dysbacteriosisGraphDetailsErrorMessage: null,
    //-----------------------------|| CHOOSE GRAPH TYPE||------------------------------------------------------
    primaryGraphType: { label: "Line", value: "line-chart" },
    tmlsGraphType: { label: "Line", value: "line-chart" },
    dysbacteriosisGraphType: { label: "Line", value: "line-chart" },
}

const dashboard = (state = initialState, action) => {

    switch (action.type) {
        //-----------------------------|| DETAILS ||---------------------------------------------------------------
        case DASHBOARD_DETAILS_PENDING: {
            return {
                ...state,
                isDashboardDetailsPending: true,
                dashboardDetailsErrorMessage: null,
            }
        }

        case SET_DASHBOARD_DETAILS: {
            const { dashboardDetails } = action.payload || {};
            return {
                ...state,
                dashboardDetails: dashboardDetails,
                isDashboardDetailsPending: false,
                dashboardDetailsErrorMessage: null,
            }
        }

        case DASHBOARD_DETAILS_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                dashboardDetailsErrorMessage: errorMessage,
                isDashboardDetailsPending: false,
                dashboardDetails: null,
            }
        }

        case DASHBOARD_DETAILS_ERROR_CLEAR: {
            return {
                ...state,
                dashboardDetailsErrorMessage: null,
            }
        }
        case CLEAR_DASHBOARD_DETAILS: {
            return {
                ...state,
                dashboardDetails: null,
            }
        }
        //-----------------------------|| USER DASHBOARD DETAILS ||------------------------------------------------
        case USER_DASHBOARD_DETAILS_PENDING: {
            return {
                ...state,
                isUserDashboardDetailsPending: true,
                userDashboardDetailsErrorMessage: null,
            }
        }

        case SET_USER_DASHBOARD_DETAILS: {
            const { dashboardDetails } = action.payload || {};
            return {
                ...state,
                userDashboardDetails: dashboardDetails,
                isUserDashboardDetailsPending: false,
                userDashboardDetailsErrorMessage: null,
            }
        }

        case USER_DASHBOARD_DETAILS_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                userDashboardDetailsErrorMessage: errorMessage,
                isUserDashboardDetailsPending: false,
                userDashboardDetails: null,
            }
        }

        case USER_DASHBOARD_DETAILS_ERROR_CLEAR: {
            return {
                ...state,
                userDashboardDetailsErrorMessage: null,
            }
        }
        case CLEAR_USER_DASHBOARD_DETAILS: {
            return {
                ...state,
                userDashboardDetails: null,
            }
        }

        //-----------------------------|| FIELD SELECT ||----------------------------------------------------------
        case FORM_FIELD_SELECT_DIALOG_OPEN: {
            return {
                ...state,
                isFieldSelectDialogOpen: true,
            }
        }
        case FORM_FIELD_SELECT_DIALOG_CLOSE: {
            return {
                ...state,
                isFieldSelectDialogOpen: false,
            }
        }

        //-----------------------------|| GRAPH FILTER ||----------------------------------------------------------
        case DASHBOARD_FILTER_DIALOG_OPEN: {
            return {
                ...state,
                isDashboardFilterDialogOpen: true,
            }
        }
        case DASHBOARD_FILTER_DIALOG_CLOSE: {
            return {
                ...state,
                isDashboardFilterDialogOpen: false,
            }
        }

        case SET_DASHBOARD_FILTER_DATA: {
            const { filter } = action.payload || {};
            return {
                ...state,
                dashboardFilter: filter,
            }
        }


        //-----------------------------|| PRIMARY ENTITY GRAPH ||--------------------------------------------------
        case PRIMARY_ENTITY_GRAPH_DETAILS_PENDING: {
            return {
                ...state,
                isPrimaryEntityGraphPending: true,
                primaryEntityGraphDetailsErrorMessage: null,
            }
        }

        case SET_PRIMARY_ENTITY_GRAPH_DETAILS: {
            const { dashboardDetails } = action.payload || {};
            return {
                ...state,
                primaryEntityGraphDetails: dashboardDetails,
                isPrimaryEntityGraphPending: false,
                primaryEntityGraphDetailsErrorMessage: null,
            }
        }

        case PRIMARY_ENTITY_GRAPH_DETAILS_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                primaryEntityGraphDetailsErrorMessage: errorMessage,
                isPrimaryEntityGraphPending: false,
                primaryEntityGraphDetails: null,
            }
        }

        case PRIMARY_ENTITY_GRAPH_DETAILS_ERROR_CLEAR: {
            return {
                ...state,
                primaryEntityGraphDetailsErrorMessage: null,
            }
        }
        case CLEAR_PRIMARY_ENTITY_GRAPH_DETAILS: {
            return {
                ...state,
                primaryEntityGraphDetails: null,
            }
        }
        //-----------------------------|| TMLS GRAPH ||------------------------------------------------------------
        case TMLS_GRAPH_DETAILS_PENDING: {
            return {
                ...state,
                isTMLSGraphPending: true,
                TMLSGraphDetailsErrorMessage: null,
            }
        }

        case SET_TMLS_GRAPH_DETAILS: {
            const { dashboardDetails } = action.payload || {};
            return {
                ...state,
                TMLSGraphDetails: dashboardDetails,
                isTMLSGraphPending: false,
                TMLSGraphDetailsErrorMessage: null,
            }
        }

        case TMLS_GRAPH_DETAILS_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                TMLSGraphDetailsErrorMessage: errorMessage,
                isTMLSGraphPending: false,
                TMLSGraphDetails: null,
            }
        }

        case TMLS_GRAPH_DETAILS_ERROR_CLEAR: {
            return {
                ...state,
                TMLSGraphDetailsErrorMessage: null,
            }
        }
        case CLEAR_TMLS_GRAPH_DETAILS: {
            return {
                ...state,
                TMLSGraphDetails: null,
            }
        }
        //-----------------------------|| DYSBACTERIOSIS GRAPH ||--------------------------------------------------
        case DYSBACTERIOSIS_GRAPH_DETAILS_PENDING: {
            return {
                ...state,
                isDysbacteriosisGraphPending: true,
                dysbacteriosisGraphDetailsErrorMessage: null,
            }
        }

        case SET_DYSBACTERIOSIS_GRAPH_DETAILS: {
            const { dashboardDetails } = action.payload || {};
            return {
                ...state,
                dysbacteriosisDetails: dashboardDetails,
                isDysbacteriosisGraphPending: false,
                dysbacteriosisGraphDetailsErrorMessage: null,
            }
        }

        case DYSBACTERIOSIS_GRAPH_DETAILS_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                dysbacteriosisGraphDetailsErrorMessage: errorMessage,
                isDysbacteriosisGraphPending: false,
                dysbacteriosisDetails: null,
            }
        }

        case DYSBACTERIOSIS_GRAPH_DETAILS_ERROR_CLEAR: {
            return {
                ...state,
                dysbacteriosisGraphDetailsErrorMessage: null,
            }
        }
        case CLEAR_DYSBACTERIOSIS_GRAPH_DETAILS: {
            return {
                ...state,
                dysbacteriosisDetails: null,
            }
        }

        //-----------------------------|| CHOOSE GRAPH TYPE||------------------------------------------------------
        case PRIMARY_ENTITY_GRAPH_TYPE: {
            const { graphType } = action.payload || {};
            return {
                ...state,
                primaryGraphType: graphType,
            }
        }
        case TMLS_GRAPH_TYPE: {
            const { graphType } = action.payload || {};
            return {
                ...state,
                tmlsGraphType: graphType,
            }
        }
        case DYSBACTERIOSIS_GRAPH_TYPE: {
            const { graphType } = action.payload || {};
            return {
                ...state,
                dysbacteriosisGraphType: graphType,
            }
        }

        default: {
            return state;
        }
    }
}

export default dashboard;